export const SPONSORED_RECO_ACTIONS = {
  FETCH_DATA: "FETCH_SPONSORED_RECO_DATA",
  IMAGE_LOADED: "SPONSORED_RECO_IMAGE_LOADED"
};

export const onImageLoad = () => ({
  type: SPONSORED_RECO_ACTIONS.IMAGE_LOADED
});